<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
			:dialog-class="''"
			:ok-title="'Search'"
			ok-variant="success"
			:cancel-title="'Clear'"
			@ok="getReportRekapDeliverys"
			@hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer " id="filter-" size="sm" :model.sync="filter.filterCustomer" @input="getFilterCustomers" @focus="getFilterCustomers" />
						<app-input-combobox-autocomplete :options="filterParts" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part " id="filter-" size="sm" :model.sync="filter.filterPart" @input="getFilterParts" @focus="getFilterParts" />
						<app-input-textbox id="fieldset-filter-po-no-customer" label-cols-sm="4" label-cols-lg="3" label="Po No Customer " label-for="filter-filter-po-no-customer" size="sm" :model.sync="filter.filterPoNoCustomer" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-filter-surat-jalan-number" label-cols-sm="4" label-cols-lg="3" label="Surat Jalan Number " label-for="filter-filter-surat-jalan-number" size="sm" :model.sync="filter.filterSuratJalanNumber" />
						<app-input-datepicker-range id="fieldset-filter-di-delivery-date" label-cols-sm="4" label-cols-lg="3" label="Tanggal Pengiriman " size="sm" :modelFrom.sync="filter.filterDiDeliveryDateFrom" :modelTo.sync="filter.filterDiDeliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						<app-input-datepicker-range id="fieldset-filter-plan-delivery-date" label-cols-sm="4" label-cols-lg="3" label="Tanggal Permintaan " size="sm" :modelFrom.sync="filter.filterPlanDeliveryDateFrom" :modelTo.sync="filter.filterPlanDeliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportRekapDeliverys"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>
		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Rekap Delivery</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-reportrekapdelivery" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportRekapDeliverys" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>

					<template #table-busy v-if="reportRekapDeliverys.length <= 0">
						<app-no-data-image :animate="true" />
					</template>

					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Tanggal Pengiriman" class="table-filter">
							<!-- <b-form-input id="input-delivery-date-table" @input="getReportRekapDeliverysWithoutLoading" v-model="filter.deliveryDate" size="sm"></b-form-input> -->
							<app-input-datepicker-range @change="getReportRekapDeliverysWithoutLoading" id="fieldset-filter-di-delivery-date" label-cols-sm="4" label-cols-lg="3" label="Di Delivery Date " size="sm" :modelFrom.sync="filter.filterDiDeliveryDateFrom" :modelTo.sync="filter.filterDiDeliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						</b-th>
						<b-th stacked-heading="Tanggal Permintaan" class="table-filter">
							<!-- <b-form-input id="input-delivery-date-table" @input="getReportRekapDeliverysWithoutLoading" v-model="filter.deliveryDate" size="sm"></b-form-input> -->
							<app-input-datepicker-range @change="getReportRekapDeliverysWithoutLoading" id="fieldset-filter-di-delivery-date" label-cols-sm="4" label-cols-lg="3" label="Di Delivery Date " size="sm" :modelFrom.sync="filter.filterPlanDeliveryDateFrom" :modelTo.sync="filter.filterPlanDeliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						</b-th>
						<b-th stacked-heading="No Surat Jalan" class="table-filter">
							<b-form-input id="input-surat-jalan-number-table" @input="getReportRekapDeliverysWithoutLoading" v-model="filter.filterSuratJalanNumber" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="No PO" class="table-filter">
							<b-form-input id="input-po-no-customer-table" @input="getReportRekapDeliverysWithoutLoading" v-model="filter.filterPoNoCustomer" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="No Part" class="table-filter">
							<!-- <b-form-input id="input-part-number-table" @input="getReportRekapDeliverysWithoutLoading" v-model="filter.partNumber" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete :options="filterParts" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part " id="filter-" size="sm" :model.sync="filter.filterPart" @change="getReportRekapDeliverysWithoutLoading" @input="getFilterParts" @focus="getFilterParts" />
						</b-th>
						<b-th stacked-heading="Nama Part" class="table-filter">
							<!-- <b-form-input id="input-part-name-table" @input="getReportRekapDeliverysWithoutLoading" v-model="filter.partName" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Jumlah Actual Delivery" class="table-filter">
							<!-- <b-form-input id="input-delivery-qty-table" @input="getReportRekapDeliverysWithoutLoading" v-model="filter.deliveryQty" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Pelanggan" class="table-filter">
							<!-- <b-form-input id="input-customer-name-table" @input="getReportRekapDeliverysWithoutLoading" v-model="filter.customerName" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer " id="filter-" size="sm" :model.sync="filter.filterCustomer" @change="getReportRekapDeliverysWithoutLoading" @input="getFilterCustomers" @focus="getFilterCustomers" />
						</b-th>
					</template>

					<template #bottom-row>
						<b-th colspan="5">&nbsp;</b-th>
						<b-th>Total</b-th>
						<b-th>{{ Number(total).toLocaleString() }}</b-th>
						<b-th>&nbsp;</b-th>
					</template>

					<template v-slot:head(frontAction)>
						<div class="d-flex justify-content-center ml-2">
							<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right">
								<b-icon-funnel />
							</b-button>
						</div>
					</template>

					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>
					
					<template v-slot:cell(deliveryDate)="row">
						{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
					</template>

					<template v-slot:cell(planDeliveryDate)="row">
						{{ row.item.planDeliveryDate | moment("DD-MMM-YYYY") }}
					</template>

					<template v-slot:cell(deliveryQty)="row">
						{{ Number(row.item.deliveryQty).toLocaleString() }}
					</template>

					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-textbox id="fieldset-po-no-customer" label-cols-lg="12"  label="No PO" label-for="input-po-no-customer" size="sm" :model.sync="row.item.poNoCustomer"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-part-number" label-cols-lg="12"  label="No Part" label-for="input-part-number" size="sm" :model.sync="row.item.partNumber"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-part-name" label-cols-lg="12"  label="Nama Part" label-for="input-part-name" size="sm" :model.sync="row.item.partName"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-delivery-qty" label-cols-lg="12"  label="Jumlah Actual Delivery" label-for="input-delivery-qty" size="sm" :model.sync="row.item.deliveryQty"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-customer-name" label-cols-lg="12"  label="Pelanggan" label-for="input-customer-name" size="sm" :model.sync="row.item.customerName"   :isEditable="false" :isUpdatable="true" />
						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(reportRekapDeliverysPaging != null ? reportRekapDeliverysPaging.dataCount : 0)"
									:per-page="(reportRekapDeliverysPaging != null ? reportRekapDeliverysPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reportrekapdelivery.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reportrekapdelivery.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportRekapDelivery from '@/models/ReportRekapDelivery/ReportRekapDelivery';
import ReportRekapDeliveryList from '@/models/ReportRekapDelivery/ReportRekapDeliveryList';
import ReportRekapDeliveryFilter from '@/filters/ReportRekapDelivery/ReportRekapDeliveryFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
export default {
	components : {
		ReportRekapDelivery, 
		ReportRekapDeliveryList, 
		ReportRekapDeliveryFilter, 
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"frontAction" : {"class" : "th-number d-stack-none"}},
				{"deliveryDate": {}, "class" : "th-delivery-date first-child", "label" : "Tanggal Pengiriman", key: 'deliveryDate', }, 
				{"planDeliveryDate": {}, "class": "th-plan-delivery-date", "label": "Tanggal Permintaan", key: "planDeliveryDate",},
				{"suratJalanNumber": {}, "class" : "th-surat-jalan-number", "label" : "No Surat Jalan", key: 'suratJalanNumber', }, 
				{"poNoCustomer": {}, "class" : "th-po-no-customer last-child", "label" : "No PO", key: 'poNoCustomer', }, 
				{"partNumber": {}, "class" : "th-part-number d-stack-none", "label" : "No Part", key: 'partNumber', }, 
				{"partName": {}, "class" : "th-part-name d-stack-none", "label" : "Nama Part", key: 'partName', }, 
				{"deliveryQty": {}, "class" : "th-delivery-qty d-stack-none", "label" : "Jumlah Actual Delivery", key: 'deliveryQty', }, 
				{"customerName": {}, "class" : "th-customer-name d-stack-none", "label" : "Pelanggan", key: 'customerName', }, 

			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportRekapDeliverys: [],
			reportRekapDeliverysPaging: {},
			filterCustomers : [],
			filterParts : [],
			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			total: 0
		}
	},	methods : {
		getReportRekapDeliverys : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			let _this = this;
			ReportRekapDelivery.getList(_this, _this.filter, _this.sortingBy, (_this.currentPage - 1), _this.pageSizeOptions)
			.then(result => {
				_this.total = 0;
				if (result != null) {
					_this.reportRekapDeliverys = result.data
					_this.reportRekapDeliverysPaging = result
					// get total disini
					ReportRekapDelivery.getListCustomUrl(_this, 'total', _this.sortingBy, (_this.currentPage - 1), _this.pageSizeOptions)
					.then(resultcount => {
						if (resultcount != null) {
							_this.total = resultcount.data;
						}
					});
				}
				_this.isDataLoading = false;
			})
			.catch(error => {
				_this.isDataLoading = false;
			});
		},
		getReportRekapDeliverysWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportRekapDelivery.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				this.total = 0;
				let _this = this;
				if (result != null) {
					this.reportRekapDeliverys = result.data
					this.reportRekapDeliverysPaging = result
					// get total disini
					ReportRekapDelivery.getListCustomUrl(_this, 'total', _this.sortingBy, (_this.currentPage - 1), _this.pageSizeOptions)
					.then(resultcount => {
						if (resultcount != null) {
							_this.total = resultcount.data;
						}
					});
				}
			})
			.catch(error => {});
		},
		getFilterCustomers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportRekapDelivery.getListCustomUrl(this,'getlistfiltercustomer' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterCustomers = result.data
				}
			})
			.catch(error => {});
		},
		getFilterParts : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportRekapDelivery.getListCustomUrl(this,'getlistfilterpart' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterParts = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportRekapDeliveryFilter();
			this.getReportRekapDeliverys();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportRekapDeliverys();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportRekapDelivery.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportRekapDelivery.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportRekapDelivery.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportRekapDelivery.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportRekapDeliverys();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportRekapDelivery.deleteMultipleData(this).then(result => {
					this.getReportRekapDeliverys();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportRekapDeliveryParent = document.getElementById('table-list-reportrekapdelivery').parentNode;
			tableReportRekapDeliveryParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportRekapDeliveryParent.scrollWidth - tableReportRekapDeliveryParent.offsetWidth) == Math.ceil(tableReportRekapDeliveryParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportRekapDeliveryParent = document.getElementById('table-list-reportrekapdelivery').parentNode;
			tableReportRekapDeliveryParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportRekapDeliveryParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportRekapDeliveryFilter();
		this.getFilterCustomers()
		this.getFilterParts()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Rekap Delivery"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportRekapDeliverys();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportRekapDeliverys();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportRekapDeliverys();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportRekapDeliverys();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportRekapDeliverys();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportRekapDelivery.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reportrekapdeliveryindex") {
					this.getReportRekapDeliverysWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_rekap_delivery").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
